// @core/api/endpoints/platform/create_platform.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreatePlatformRequest,
  PlatformResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Create a new platform
 * Creates a new platform instance with the specified configuration. The creating user automatically becomes the platform owner with full administrative privileges.
 */
export async function CreatePlatform(
  data: CreatePlatformRequest,
  options?: RequestOptions
): Promise<PlatformResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/platforms`;
  const requestOptions = options;
  return client.post<PlatformResponse>(requestPath, data, requestOptions);
}
